import axios from 'axios'
import { clone, objectSnakeToCamelCase, getDefaultStrDate } from '@/util/libUtil.js'

const state = () => ({
	resources: {
		isOpenResources: false,
		isLoadingResources: false,
		resourcesData: [],
		releasesData: [],
	},
	paths: {
		resourcesPath: '/api/scraping/yoigo/resources/grupomm',
		releasesPath: '/api/scraping/yoigo/releases/grupomm',
	}
})

const mutations = {
	resourcesData(state, val) {
		state.resources.resourcesData = val
	},
	releasesData(state, val) {
		state.resources.releasesData = val
	},
	isOpenResources: (state, val) => {
		state.resources.isOpenResources = val
	},
	isLoadingResources: (state, val) => {
		state.resources.isLoadingResources = val
	},
	resetCoverageData: (state) => {
		state.resources.resourcesData = [];
	}
}

const actions = {
	async getResources({ dispatch, getters, state, commit }) {
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.resourcesPath))
			commit('resourcesData', res.data)
		} catch (error) {
			console.log(error)
		}
	},
	async getReleases({ dispatch, getters, state, commit }) {
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.releasesPath))
			commit('releasesData', res.data)
		} catch (error) {
			console.log(error)
		}
	}
}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	)
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}